import { useEffect, useMemo, useState } from 'react';
import {
  measureAll,
  getMeasuredAudioDuration,
} from '@src/services/audioDuration';

/**
 * Measures the blocks' audio and bumps a version once the whole queue settles,
 * so the caller re-estimates once rather than once per file.
 */
const useBlockAudioDurations = (blocks, blockIds, enabled) => {
  const [version, setVersion] = useState(0);

  // A string, so the effect tracks the urls, not the array identity.
  const signature = useMemo(
    () =>
      enabled && Array.isArray(blockIds)
        ? blockIds.map((id) => blocks?.[id]?.audioLink ?? '').join('|')
        : '',
    [blocks, blockIds, enabled],
  );

  useEffect(() => {
    if (!signature) return undefined;
    // `undefined`, not falsy: a failed measurement caches 0 and must not retry.
    const urls = signature
      .split('|')
      .filter((url) => url && getMeasuredAudioDuration(url) === undefined);
    if (!urls.length) return undefined;

    let cancelled = false;
    measureAll(urls).then(() => {
      if (!cancelled) setVersion((previous) => previous + 1);
    });
    return () => {
      cancelled = true;
    };
  }, [signature]);

  return version;
};

export default useBlockAudioDurations;
